import { render, staticRenderFns } from "./ModalProfileView.vue?vue&type=template&id=c5df91b4&scoped=true"
import script from "./ModalProfileView.vue?vue&type=script&lang=js"
export * from "./ModalProfileView.vue?vue&type=script&lang=js"
import style0 from "./ModalProfileView.vue?vue&type=style&index=0&id=c5df91b4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5df91b4",
  null
  
)

export default component.exports